import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from "../../../Basic/Select";
import BillingTerm, { BillingTermValidation } from './BillingTerm';
class BillingMethod extends React.Component {
    render() {
        const p = this.props;
        const lookup = window.osa.lookup.customerDetails.billingMethod;
        //TODO: Change numbers to enums
        const term = (p.billingMethod == "0001" || p.billingMethod == "0005") ?
            <BillingTerm name={p.name} billingMethod={p.billingMethod} disabled={p.disabled} /> : null;
        return (
            <div className="form-group">
                <div className="row">
                    <div className="col-md-12">
                        <Select name={p.name} title={lookup.title} items={lookup.items} customClass="col-sm-4" disabled={p.disabled} />
                    </div>
                </div>
                {term}
            </div>
        );
    }
}

BillingMethod.propTypes = {
    name: PropTypes.string.isRequired,
    billingMethod: PropTypes.string,
    disabled: PropTypes.bool,
};

const mapStateToProps = (state) => (
    {        
        billingMethod: state.form.billingMethod,
    }
);

export default connect(mapStateToProps)(BillingMethod);

export function BillingMethodValidation(name, billingMethod) {
    if (billingMethod == "0001" || billingMethod == "0005")
        return [...BillingTermValidation(name)];
    else
        return [];
}
